
export interface JobDetail {
  id: number;
  product: string;
  product_info: string;
  customer_name: string;
  race: string;
  age?: number | null;
  sex: string;
  gender?: string;
  location: string;
  health_condition: string;
  additional_info: string;
  description: string | null;
  additional_health_info?: string | null;
  address?: string | null;
  add_state?: string | null;
  weight?: string | number | null;
  height?: string | number | null;
  // New detailed fields
  medical_history?: string;
  surgical_history?: string;
  conditions_list?: MedicalCondition[];
  religion?: string;
  nationality?: string;
}

export interface MedicalCondition {
    primary_id: number;
    secondary_id: number;
    primary_name: string;
    secondary_name: string;
}

export const JobStatus = {
  draft: "draft",
  open: "open",
  inProgress: "in-progress",
  completed: "completed",
  cancelled: "cancelled",
  closed: "closed"
};

export const ALL_STATUSES = Object.values(JobStatus);

export interface Job {
  id: number;
  role: string | null;
  created_at: string;
  status: string;
  first_name: string | null;
  last_name: string | null;
  product_name: string;
  interest_count?: number; // Present in list view
  total_interest?: number; // Present in detail view
  job_location: string | null;
  job_experience: string | null;
  job_gender: string | null;
  job_type?: string | null;
  order_id: number | null;
  salary?: string | null;
  job_detail_location?: string | null;
  // Fields from detail view
  created_by?: number;
  created_by_name?: string;
  creator?: string;
  remarks?: string | null;
  description?: string | null;
  assignee?: number | null;
  assigneeName?: string | null;
  job_details?: JobDetail[];

  // Patient info potentially on root object for detail view
  customer_name?: string;
  race?: string;
  age?: number;
  sex?: string;
  location?: string;
  health_condition?: string;
  additional_info?: string;
  additional_health_info?: string | null;
  address?: string | null;
  add_state?: string | null;
  weight?: string | number | null;
  height?: string | number | null;

  // New fields from order_id fetch
  cust_location?: string;
  cust_gender?: string;
  cust_weight?: number;
  cust_height?: number;
  cust_race?: string;
  cust_religion?: string;
  cust_nationality?: string;
  cust_medical_condition?: string;
  cust_medical_history?: string;
  cust_surgical_history?: string;
  cust_additional_health_info?: string;
  cust_medical_condition_list?: MedicalCondition[];
}

export interface ApplicationPayload {
  job_id: number;
  caregiver_id: string | number | null;
  created_at: string;
  from: string;
  name: string;
  mobile: string;
}

export interface Caregiver {
    id: number;
    first_name: string;
    last_name: string;
    mobile?: string;
    add_city?: string;
    add_country?: string;
    // Added type property which is returned by the API and used in login verification.
    type?: string;
}

export interface InterestedApplicant {
  id: number;
  job_id: number;
  caregiver_id: number | null;
  created_at: string;
  from: string;
  name: string;
  mobile: string | null;
  first_name: string;
  last_name: string;
}

export interface CreateJobDetail {
    product: string;
    product_info: string;
    customer_name: string;
    race: string;
    age: number;
    gender: string;
    location: string;
    health_condition: string;
    additional_info: string;
    description: string;
}

export interface CreateJobData {
    status: string;
    role: string;
    order_detail_id: number;
    created_by: number;
    created_at: string;
    description: string;
    remarks: string;
    salary: number;
    weight: number;
    height: number;
    job_type?: string;
    job_details?: CreateJobDetail[];
}

export interface OrderResponse {
    id: number;
    customers_info: {
        full_name: string;
        age: number;
        sex: string;
        race: string;
        add_city: string;
        add_state: string;
        medical_condition: string | null;
        medical_history: string | null;
        additional_health_info: string | null;
        weight: number | null;
        height: number | null;
    };
    order_detail: {
        id: number;
        product_name: string;
        remarks: string;
    }[] | {
        id: number;
        product_name: string;
        remarks: string;
    };
}
